import { createAsyncAction, ActionType, createAction } from 'typesafe-actions';

const DISPATCH_IS_ERROR = 'comn/erorr/DISPATCH_IS_ERROR';
const DISPATCH_NOT_ERROR = 'comn/erorr/DISPATCH_NOT_ERROR';

const DISPATCH_IS_MESSAGE = 'comn/erorr/DISPATCH_IS_MESSAGE';
const DISPATCH_NOT_MESSAGE = 'comn/erorr/DISPATCH_NOT_MESSAGE';

export const IS_MESSAGE = createAction(DISPATCH_IS_MESSAGE)<{
  messageCode: string;
  message: string;
  isHistoryBack: boolean;
  isRefresh: boolean;
}>();
export const ISNO_MESSAGE = createAction(DISPATCH_NOT_MESSAGE)<void>();

export const IS_ERROR = createAction(DISPATCH_IS_ERROR)<{
  errorCode: string;
  errorMessage: string;
  isHistoryBack: boolean;
  isRefresh: boolean;
}>();
export const ISNO_ERROR = createAction(DISPATCH_NOT_ERROR)<void>();
const actions = {
  IS_MESSAGE,
  ISNO_MESSAGE,
  IS_ERROR,
  ISNO_ERROR
};

export type ComnMessageAction = ActionType<typeof actions>;
